export default __webpack_public_path__ + "static/media/NeueMontreal-Light.b94da60c.otf";